var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.1564,
    y: 7.83313,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "#831213"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3563 14.8333C46.4027 14.8333 54.5563 22.9869 54.5563 33.0333C54.5563 43.0797 46.4027 51.2333 36.3563 51.2333C26.3099 51.2333 18.1562 43.0797 18.1562 33.0333C18.1562 22.9869 26.3099 14.8333 36.3563 14.8333Z",
    fill: "#CF1011"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3566 28.7234C38.7299 28.7234 40.6664 30.6453 40.6664 33.0331C40.6664 35.4064 38.7445 37.3429 36.3566 37.3429C33.9834 37.3429 32.0469 35.421 32.0469 33.0331C32.0469 30.6599 33.9688 28.7234 36.3566 28.7234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4583 21.7638C37.8123 21.7784 39.1519 22.0405 40.404 22.5209C41.6562 23.0014 42.821 23.7003 43.8402 24.603L43.8693 24.6321C46.1843 26.6997 47.4511 29.4952 47.6112 32.3635C47.7859 35.2464 46.8541 38.1875 44.8011 40.5171L44.772 40.5462C42.7045 42.8613 39.909 44.128 37.0407 44.2881C34.1578 44.4629 31.2167 43.531 28.8871 41.4781C26.5575 39.4105 25.2762 36.6005 25.116 33.7176C24.9413 30.8347 25.8731 27.8936 27.9261 25.564L28.9016 26.423C27.0816 28.476 26.2663 31.0822 26.4119 33.6302C26.572 36.1782 27.6931 38.668 29.7461 40.488C31.7991 42.308 34.4053 43.1233 36.9533 42.9777C39.5013 42.8176 41.9911 41.6965 43.8111 39.6435L43.8402 39.6144C45.6456 37.5614 46.461 34.9697 46.3008 32.4363C46.1407 29.8883 45.0195 27.3985 42.9666 25.5785L42.9375 25.5494C42.0493 24.7632 41.0301 24.1517 39.9381 23.7294C38.8315 23.3072 37.6522 23.0742 36.4583 23.0597L36.4728 21.7493L36.4583 21.7638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9504 21.8365C30.7366 21.8365 31.4355 22.1569 31.9451 22.6665C32.4547 23.1761 32.775 23.8895 32.775 24.6612C32.775 25.4474 32.4547 26.1463 31.9451 26.6559C31.4355 27.1655 30.7221 27.4858 29.9504 27.4858C29.1641 27.4858 28.4653 27.1655 27.9557 26.6559C27.4461 26.1463 27.1257 25.4329 27.1257 24.6612C27.1257 23.8749 27.4461 23.1761 27.9557 22.6665C28.4653 22.1569 29.1787 21.8365 29.9504 21.8365ZM31.0278 23.5983C30.7512 23.3217 30.3726 23.1469 29.9504 23.1469C29.5281 23.1469 29.1496 23.3217 28.8729 23.5983C28.5963 23.8749 28.4216 24.2535 28.4216 24.6757C28.4216 25.098 28.5963 25.4765 28.8729 25.7532C29.1496 26.0298 29.5281 26.2045 29.9504 26.2045C30.3726 26.2045 30.7512 26.0298 31.0278 25.7532C31.3045 25.4765 31.4792 25.098 31.4792 24.6757C31.4792 24.2535 31.3045 23.8749 31.0278 23.5983Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_345",
    x: 0.656372,
    y: 0.13313,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.1562,
    y: 14.8333,
    width: 36.4,
    height: 36.4,
    rx: 18.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRender);
export default __webpack_public_path__ + "static/media/render.dee11f5be8681b20fea2a4bef76086c3.svg";
export { ForwardRef as ReactComponent };